function checkPincode() {
    const pincode = document.getElementById("pincode").value;
    const deliveryMessage = document.getElementById("delivery-message");

    // Check if the pincode is valid (6-digit number)
    if (pincode.length === 6 && /^[0-9]+$/.test(pincode)) {
        // Get today's date
        const today = new Date();

        // Calculate the start and end dates for the delivery range
        const startDate = new Date(today);
        startDate.setDate(today.getDate() + 3); // 3 days from today

        const endDate = new Date(today);
        endDate.setDate(today.getDate() + 6); // 6 days from today

        // Format the dates (e.g., "Wed, 13 Nov")
        const options = { weekday: 'short', day: 'numeric', month: 'short' };
        const formattedStartDate = startDate.toLocaleDateString('en-US', options);
        const formattedEndDate = endDate.toLocaleDateString('en-US', options);

        // Display the message with the date range
        deliveryMessage.innerText = `Delivery between ${formattedStartDate} - ${formattedEndDate}`;
    } else {
        // Display error message if the pincode is invalid
        deliveryMessage.innerText = "Please enter a valid 6-digit pincode.";
    }
}
